import React from "react";
import "./OfferList.css";
import { formatUnits } from "ethers";
import offersListIcon from "../../../../assets/offers-list.svg";

interface OfferAddressLinkProps {
  address: string;
}

const OfferAddressLink = ({ address }: OfferAddressLinkProps) => {
  const etherscanUrl = `https://etherscan.io/address/${address}`;
  
  // Function to truncate address with dots in the middle
  const truncateAddress = (address: string) => {
    if (address.length <= 10) return address;
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  };

  return (
    <a href={etherscanUrl} className="offers-address" target="_blank" rel="noopener noreferrer">
      {truncateAddress(address)}
    </a>
  );
};

interface Offer {
  current_price: string;
  expiration_time: number;
  offerer: string;
}

interface OfferListProps {
  offers: Offer[];
  refreshButton?: React.ReactNode;
}

const OfferList = ({offers, refreshButton}: OfferListProps) => {
    return (
        <div className="offersContainer">
            <div className="offersContent gradient">
              <div className="offers-header">
                <div className="offers-header-left">
                  <img className="offers-list-icon" src={offersListIcon} alt="offers list icon" />
                  <h2>Offers</h2>
                </div>
                {refreshButton && (
                  <div className="offers-header-right">
                    {refreshButton}
                  </div>
                )}
              </div>
                {
                  offers.length !== 0 ? (
                    <div className="table-container">
                      <table className="offer-list">
                        <thead>
                          <tr>
                            <th>Price</th>
                            <th>Expiration</th>
                            <th>From</th>
                          </tr>
                        </thead>
                        <tbody>
                          {offers.map((offer, index) => (
                            <tr key={index}>
                              {
                                offer.current_price && 
                                <td data-label="Price">
                                  {formatUnits(offer.current_price, 18)} WETH
                                </td>
                              }
                              <td data-label="Expiration">
                                {new Date(offer.expiration_time * 1000).toISOString().split("T")[0]}{" "}
                                {new Date(offer.expiration_time * 1000).toTimeString().split(" ")[0]}
                              </td>
                              <td data-label="From"><OfferAddressLink address={offer.offerer} /></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div>
                      <h4>No offers yet</h4>
                    </div>
                  )
                }
            </div>
        </div>
    );
}

export default OfferList;